import OrigenDeudaCrud from './OrigenDeudaCrud'
export {OrigenDeudaCrud}
export default OrigenDeudaCrud
